module.exports = __webpack_public_path__ + "img/share-table-right.ec4b76f7.png";